import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { CircularProgress, Box } from "@mui/material";
import { useDualMsal } from "../contexts/MsalContext";

/**
 * Handles the OIDC redirect callback. The MsalContext useEffect does
 * the actual code-for-token exchange when it sees `code=` in the URL;
 * this component just keeps the route mounted long enough for that
 * exchange to complete, then navigates home.
 */
export default function AuthCallback() {
  const navigate = useNavigate();
  const { isInitialized, isAuthenticated } = useDualMsal();

  useEffect(() => {
    if (isInitialized) {
      navigate(isAuthenticated ? "/" : "/?auth=failed", { replace: true });
    }
  }, [isInitialized, isAuthenticated, navigate]);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
      }}
    >
      <CircularProgress />
    </Box>
  );
}
